// extracted by mini-css-extract-plugin
export default {"root":"i2TwS6Hh","enter":"_1oCZOe0f","enterActive":"JPzq_6k_","exit":"_2cSp_Rch","exitActive":"_3TQT7TmW"};